import type { CSSProperties, ReactNode } from 'react';

interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  tone?: 'canvas' | 'sunken';
  align?: 'left' | 'center';
  className?: string;
  style?: CSSProperties;
}

export function Section({
  id,
  eyebrow,
  title,
  description,
  children,
  tone = 'canvas',
  align = 'left',
  className = '',
  style,
}: SectionProps) {
  return (
    <section
      id={id}
      className={className}
      style={{
        background: tone === 'sunken' ? 'var(--bg-sunken)' : 'transparent',
        borderTop: tone === 'sunken' ? '1px solid var(--border-hair)' : undefined,
        borderBottom: tone === 'sunken' ? '1px solid var(--border-hair)' : undefined,
        ...style,
      }}
    >
      <div className="mx-auto max-w-6xl px-6 py-20 md:py-24">
        {(eyebrow || title || description) && (
          <div className={`mb-12 ${align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}`}>
            {eyebrow && (
              <p
                className="text-[11px] font-semibold uppercase"
                style={{ color: 'var(--color-accent-600)', letterSpacing: '0.10em' }}
              >
                {eyebrow}
              </p>
            )}
            {title && (
              <h2
                className="mt-3"
                style={{
                  fontSize: '2rem',
                  lineHeight: '2.4rem',
                  fontWeight: 600,
                  letterSpacing: '-0.028em',
                  color: 'var(--fg-high)',
                }}
              >
                {title}
              </h2>
            )}
            {description && (
              <p
                className="mt-4 text-[15px] leading-relaxed"
                style={{ color: 'var(--fg-mid)' }}
              >
                {description}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
